import { useSelector } from 'react-redux';
import { IdeaState } from '@/reducers/idea';

export default function useIdeaFavoriteList() {
  const ideaFavoriteList = useSelector((state: { idea: IdeaState }) => state.idea.ideaFavoriteList);

  return ideaFavoriteList;
}
